import { CheckIcon, DeleteIcon } from "@chakra-ui/icons";
import { Box, Button, Divider, Flex, Stack, Text } from "@chakra-ui/react";
import React from "react";
import { EditContainer } from "./Shared";

type Guarantor = {
  title: string;
  fullName: string;
  email: string;
  occupation: string;
  phone: string;
  company: string;
  relationship: string;
  isVerified: boolean;
  no_of_years: number;
};

type Props = {
  actions: {
    onAccept: () => Promise<void>;
    onDelete: (index: number) => Promise<void>;
    onReject: () => Promise<void>;
  };
  guanrantors: Guarantor[];
  isOpen: boolean;
  loading: { accept: boolean; reject: boolean };
  onClose: () => void;
};

export default function ReviewGuarantors({
  actions,
  guanrantors,
  isOpen,
  loading,
  onClose,
}: Props) {
  return (
    <EditContainer header="Review guarantors" isOpen={isOpen} onClose={onClose}>
      <Stack spacing={3}>
        <Stack spacing={2}>
          {guanrantors.map((guarantor, index) => {
            return (
              <Box key={guarantor.fullName}>
                <Flex justify="space-between" align="baseline">
                  <Box flex={1}>
                    <Text fontWeight="semibold">{`${guarantor.title} ${guarantor.fullName}`}</Text>
                    <Text>
                      {guarantor.occupation}, {guarantor.company}
                    </Text>
                    <Text>
                      {guarantor.email}, {guarantor.phone}
                    </Text>
                    <Text>
                      <b>Relationship: </b>
                      {guarantor.relationship}
                    </Text>
                    <Text>
                      <b>Number of Years: </b>
                      {guarantor.no_of_years}
                    </Text>
                  </Box>

                  <Stack ml={[0, 6]} align="center">
                    {guarantor.isVerified ? (
                      <CheckIcon color="green.500" />
                    ) : (
                      <Button
                        size="sm"
                        leftIcon={<DeleteIcon />}
                        variant="link"
                        colorScheme="red"
                        onClick={() => actions.onDelete(index)}
                      >
                        Delete
                      </Button>
                    )}
                  </Stack>
                </Flex>
                <Divider />
              </Box>
            );
          })}
        </Stack>
        <Stack isInline mt={4} justifyContent="space-between" width="100%">
          <Button
            colorScheme="red"
            isDisabled={guanrantors.length > 1}
            isLoading={loading.reject}
            width="200px"
            loadingText="Processing..."
            onClick={actions.onReject}
          >
            Reject
          </Button>
          <Button
            colorScheme="blue"
            width="200px"
            // isDisabled={guanrantors.length > 1}
            isLoading={loading.accept}
            loadingText="Processing..."
            onClick={actions.onAccept}
          >
            Accept
          </Button>
        </Stack>
      </Stack>
    </EditContainer>
  );
}
